var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342.074,
    height: 342.089,
    viewBox: "0 0 342.074 342.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2934",
    "data-name": "Groupe 2934",
    transform: "translate(16303.394 3088.902)",
    opacity: 0.175,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12496",
    "data-name": "Trac\\xE9 12496",
    d: "M211.069,73.1V-7.441H130.52V73.11h.011a52.233,52.233,0,0,1-52.224,52.214v.022H-21.486l131.668,209.3H211.069l-86.35-137.279A132.622,132.622,0,0,0,211.069,73.1",
    transform: "translate(-16172.389 -3081.459)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12497",
    "data-name": "Trac\\xE9 12497",
    d: "M0,120.5V329.822H80.538V120.5A52.127,52.127,0,0,1,130.694,68.48h.065c.682-.033,1.32-.206,2-.206h78.546v-80.54H132.762A132.768,132.768,0,0,0,0,120.5",
    transform: "translate(-16303.394 -3076.636)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBg);
export default __webpack_public_path__ + "static/media/logoBG.750b6b260b17992890da7774724f2def.svg";
export { ForwardRef as ReactComponent };